import React, { useEffect } from "react";

// Componentes comunes
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import VideoBackground from "../components/VideoBackground";
import GetInTuch from "../components/getInTuch";
import Seo from "../components/Seo";
import ComparativaSmartReader from "../components/ComparativaSmartReader";
import BeneficiosSection from "../components/BeneficiosSection";
import SmartReaderInfo from "../components/SmartReaderInfo";

// Estado global
import useStore from "../store/useStore";
import VideoComex from "../components/VideoComex";

// Datos estáticos de beneficios
const productos = [
  {
    title: "Flexibilidad",
    description:
      "Adaptación a los requerimientos de cada cliente, desarrollos con procesos ágiles que garantizan respuesta inmediata.",
  },
  {
    title: "Integración con ERPs",
    description:
      "Potencia ampliada al integrar la data de su sistema en la plataforma. Automatización que representa un importante retorno de inversión.",
  },
  {
    title: "Reportes y KPIs",
    description:
      "Información de sus operaciones a nivel internacional para una mejor toma de decisiones, integración con herramientas de Power BI.",
  },
  {
    title: "Workflow de aprobación",
    description:
      "Seteo de flujos de avance de procesos automático o bajo requerimiento de confirmación ante acciones críticas.",
  },
  {
    title: "Alertas y vencimientos",
    description:
      "Automatización del seguimiento de calendarios a través de seteo predeterminado o personalizado.",
  },
  {
    title: "Reducción de costos",
    description:
      "Eliminación de cargas manuales, data entry y errores de tipeo de factor humano determinan la reducción de multas y pérdidas de tiempo.",
  },
];

export default function SmartReader() {
  // Estado global desde Zustand
  const {
    smartReaderHeroes,
    getSmartReaderHeroes,
    seoSmartReaders,
    fetchSeoSmartReaders,
    smartReaders,
    fetchSmartReaders,
  } = useStore();

  const API_URL = process.env.REACT_APP_STRAPI_URL;

  // Efecto para cargar datos al montar el componente
  useEffect(() => {
    getSmartReaderHeroes();
    fetchSeoSmartReaders();
    fetchSmartReaders(); // Cargar smartReaders
  }, [getSmartReaderHeroes, fetchSeoSmartReaders, fetchSmartReaders]);

  return (
    <>
      {/* SEO dinámico */}
      <Seo
        metaTitle={seoSmartReaders[0]?.metatitle}
        metaDescription={seoSmartReaders[0]?.metadescription}
        metaImage={seoSmartReaders[0]?.metaimage?.url}
        metaKeywords={seoSmartReaders[0]?.metakeywords}
        canonicalURL={seoSmartReaders[0]?.canonicalurl}
      />

      {/* Encabezado */}
      <header>
        <Navbar tabIndex={0} aria-label="Navegación principal" />
      </header>

      {/* Contenido principal */}
      <main className="bg-sidom-light dark:bg-sidom-blue">
        {/* Sección hero con video dinámico */}
        <section data-aos="fade-up" aria-label="Hero Smart Reader">
          {smartReaderHeroes?.length === 0 || !smartReaderHeroes ? (
            // Mostrar placeholder mientras carga
            <VideoBackground
              video="/placeholder.mp4"
              titulo1="Cargando..."
              titulo2="Espere un momento"
              textbutton="SOLICITAR DEMO"
              logo="/placeholder-logo.png"
              tabIndex={0}
              aria-label="Video de carga"
            />
          ) : (
            // Render dinámico del contenido home
            smartReaderHeroes.map((item) => (
              <VideoBackground
                key={item.id || item.titulo}
                video={`${API_URL}${item.video[0]?.url}`}
                titulo1={item.titulo}
                titulo2={item.text}
                textbutton="SOLICITAR DEMO"
                link="/contact"
                logo={`${API_URL}${
                  item.img[0]?.formats?.thumbnail?.url ||
                  item.img?.url ||
                  "/placeholder-logo.png"
                }`}
                tabIndex={0}
                aria-label={`Video de ${item.titulo}`}
              />
            ))
          )}
        </section>

        {/* Contenedor visual sin contenido (posiblemente para separación visual) */}
        <div
          className="container bg-sidom-light dark:bg-sidom-blue overflow-hidden"
          tabIndex={0}
          aria-label="Separador visual"
        />

        {/* Video demostrativo embebido */}
        <section aria-label="Video demostrativo">
          <VideoComex
            key={smartReaders[0]?.id}
            video={smartReaders[0]?.video?.url}
            controls={false}
            autoPlay={true}
            muted={true}
            loop={true}
            tabIndex={0}
            aria-label="Video demostrativo de Smart Reader"
          />
        </section>

        {/* Título principal de la sección informativa */}
        <SmartReaderInfo
          tabIndex={0}
          aria-label="Información de Smart Reader"
        />

        {/* Sección de beneficios listados */}
        <BeneficiosSection
          productos={productos}
          tabIndex={0}
          aria-label="Beneficios de Smart Reader"
        />

        {/* Comparativa entre procesos */}
        <ComparativaSmartReader
          tabIndex={0}
          aria-label="Comparativa de procesos de Smart Reader"
        />
      </main>

      {/* Contacto final y footer */}
      <GetInTuch tabIndex={0} aria-label="Formulario de contacto" />
      <footer>
        <Footer tabIndex={0} aria-label="Pie de página" />
      </footer>
      <Switcher tabIndex={0} aria-label="Botón para cambiar tema" />
    </>
  );
}
